exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mute-card-content-container{margin-top:.5em;text-align:right}.mute-card-content-container button{width:10em}", ""]);

// exports
